import styled from 'styled-components';
import { getPropertyLabel } from 'customer-data-property-utils/PropertyDisplay';
import PropertyValueWithTooltip from './PropertyValueWithTooltip';
import { List } from 'foundations-components/transitional/components/List';
import { View } from 'foundations-components/transitional/components/View';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const CardFieldHeader = styled.span.withConfig({
  displayName: "DefaultProperties__CardFieldHeader",
  componentId: "sc-1k1ziof-0"
})(({
  theme
}) => `
  font-weight: ${theme.typography['display-100'].fontWeight};
  &::after {
    content: ' ';
  }
`);
const DefaultProperties = ({
  object,
  objectTypeDefinition,
  items,
  getIsUngated,
  currencyFormatOptions
}) => {
  return /*#__PURE__*/_jsx(List, {
    padding: "0",
    margin: "0",
    "data-test-id": "cdbc-properties-default",
    children: items.map((item, index) => {
      const name = item.definition.name;
      const label = getPropertyLabel(item.definition);
      return /*#__PURE__*/_jsxs(View, {
        "data-selenium-test": "card-property",
        "data-test-id": `cdbc-property-${index}`,
        "data-card-style": "COMFORTABLE",
        margin: "0",
        padding: "0",
        children: [label && /*#__PURE__*/_jsxs(CardFieldHeader, {
          "data-test-id": "cdbc-property-label",
          children: [label, ":"]
        }), /*#__PURE__*/_jsx("span", {
          "data-test-id": "cdbc-property-value",
          children: /*#__PURE__*/_jsx(PropertyValueWithTooltip, {
            object: object,
            objectTypeDefinition: objectTypeDefinition,
            item: item,
            currencyFormatOptions: currencyFormatOptions,
            getIsUngated: getIsUngated,
            isCompact: false
          })
        })]
      }, name);
    })
  });
};
export default DefaultProperties;